import { useState } from "react";
import { Box, Container, Tab, Tabs } from "@mui/material";
import LevelUnlocksContent from "./LevelUnlocksContent";
import XpAchievmentsContent from "./XpAchievmentsContent";

export default function LevelUnlocksPage() {
  const [tab, setTab] = useState(0);

  const handleChange = (e, newVal) => setTab(newVal);

  return (
    <Container sx={{ p: 0 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3, p: 0 }}>
        <Tabs value={tab} onChange={handleChange} aria-label="xp-tabs">
          <Tab label="XP Level Unlocks" />
          <Tab label="XP Acheivements" />
        </Tabs>
      </Box>

      {tab === 0 && <LevelUnlocksContent />}

      {tab === 1 && <XpAchievmentsContent />}
    </Container>
  );
}
